// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"352":"32b5bd4b","3755":"57e05cbe"}[chunkId] + ".chunk.css");